import React from "react";
import { SectionTitleComponent } from "../../../components/section-title.component";

interface IAboutUsComponentProps {}

export const AboutUsComponent: React.FC<IAboutUsComponentProps> = (
    props: IAboutUsComponentProps
) => {
    const section = {
        title: "About",
        subTitle:
            "Your trusted partner in Payroll, Statutory Compliance & Background Verification Services.",
    };

    return (
        <section id="about" className="about section">
            <SectionTitleComponent
                title={section.title}
                subTitle={section.subTitle}
            />
            <div className="container">
                <div className="row gy-4">
                    <div
                        className="col-lg-6 content"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            iTalent Outsourcing Services Pvt. Ltd. is a trusted
                            leader in delivering end-to-end solutions in
                            Statutory Compliance, Payroll Management, and
                            Background Verification services. With a strong
                            national presence and a deep regional footprint, we
                            provide customized, dependable services that enable
                            businesses to operate smoothly while staying fully
                            compliant with all regulatory requirements.
                        </p>

                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            Our strength lies in the perfect blend of
                            experienced professionals, well-defined operational
                            processes, and deep domain expertise. This synergy
                            empowers us to offer proactive and tailored
                            solutions to each client—ensuring accuracy,
                            integrity, and business continuity.
                        </p>

                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            Payroll & Statutory Compliance Services
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <p
                                className="text-justify"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                A robust and reliable payroll and compliance
                                system is vital for the smooth functioning of
                                any organization. At iTalent, we offer
                                comprehensive payroll and statutory compliance
                                services designed to:
                            </p>
                        </p>

                        <p data-aos="fade-up" data-aos-delay="600">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            <span className="text-justify">
                                Ensure timely and accurate salary disbursement
                            </span>
                        </p>

                        <p data-aos="fade-up" data-aos-delay="700">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            <span className="text-justify">
                                Comply with all statutory obligations and labor
                                laws
                            </span>
                        </p>
                        <p data-aos="fade-up" data-aos-delay="800">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            <span className="text-justify">
                                Avoid penalties, interest, and legal risks
                            </span>
                        </p>
                        <p data-aos="fade-up" data-aos-delay="800">
                            <i className="bi bi-check2-circle"></i>&nbsp;&nbsp;
                            <span className="text-justify">
                                Enhance employee trust, morale, and financial
                                confidence
                            </span>
                        </p>
                    </div>
                    <div className="col-lg-6">
                        <img
                            loading="lazy"
                            src="/assets/image-gallery/DSC08166.webp"
                            className="img-fluid border-radius-10px"
                            alt="about-us-image"
                            data-aos="fade-up"
                            data-aos-delay="900"
                        />
                    </div>
                    <div>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="900"
                        >
                            We help you focus on your core operations while we
                            manage the complexities of constantly evolving
                            compliance regulations and payroll systems.
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="900"
                        >
                            We proudly serve a diverse range of industries such
                            as IT, Manufacturing, Education, Retail,
                            Construction, Healthcare, and beyond, with a strong
                            focus on Pan India operations. Our team of
                            experienced professionals ensures seamless
                            compliance, effective risk management, and tailored
                            legal support to meet your unique business needs.
                        </p>
                        <p
                            className="text-justify"
                            data-aos="fade-up"
                            data-aos-delay="1000"
                        >
                            At iTalent Outsourcing Services, we are driven by
                            our core values of quality, integrity, and client
                            success. As we continue to grow, our commitment to
                            excellence remains the foundation of everything we
                            do.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
